import React, { FC, useState, useEffect, useRef } from 'react';

import { convertTime } from '../../../utils/Agents/convertTime';
import { AgentStatus } from '../../../types/enums';

type TimerProps = {
  agentStatus: string;
  className: string;
  /** @deprecated Не используется: таймер «В работе» стартует только при Working */
  timeToRequest?: number | null;
};

const Timer: FC<TimerProps> = ({ agentStatus, className }) => {
  const [time, setTime] = useState(0);
  const [activeTimer, setActiveTimer] = useState(false);
  const workStartedAtRef = useRef<number | null>(null);

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | undefined;
    if (activeTimer && workStartedAtRef.current != null) {
      intervalId = setInterval(() => {
        const startedAt = workStartedAtRef.current;
        if (startedAt == null) return;
        setTime(Math.max(0, Date.now() - startedAt));
      }, 1000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [activeTimer]);

  useEffect(() => {
    if (agentStatus === AgentStatus.Working) {
      if (workStartedAtRef.current == null) {
        workStartedAtRef.current = Date.now();
        setTime(0);
      }
      setActiveTimer(true);
      return;
    }
    workStartedAtRef.current = null;
    setActiveTimer(false);
    setTime(0);
  }, [agentStatus]);

  const safeTime = Number.isFinite(time) ? time : 0;
  const minutes = Math.floor((safeTime / 1000 / 60) % 60);
  const seconds = Math.floor((safeTime / 1000) % 60);
  return <div className={className}>{convertTime(minutes, seconds)}</div>;
};

export default Timer;
